import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { ReceiptComponent } from './component/receipt.component';
import { ContractsModule } from '../../dossiers/contracts/contracts.module';



@NgModule({
  declarations: [ReceiptComponent],
  imports: [
    CommonModule,
    FormPlycaModule,
    ContractsModule
  ],
  exports: [ReceiptComponent]
})
export class ReceiptModule {

}